import * as PrintReportActions from '../actions/print.actions';

const initialState = {
  submitting: false,
  error: null,
  message: '',
  fileName: '',
  fileUrl: '',
};

const print = (state = initialState, action) => {
  switch (action.type) {
    case PrintReportActions.PRINT_REPORT:
      return {
        ...state,
        submitting: true,
        error: null,
        message: '',
        fileName: '',
        fileUrl: '',
      };
    case PrintReportActions.PRINT_REPORT_SUCCESS:
      return {
        ...state,
        submitting: false,
        fileName: action.payload.data.fileName,
        fileUrl: action.payload.data.fileUrl,
      };
    case PrintReportActions.PRINT_REPORT_FAIL:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
        message: action.payload.message,
      };
    case PrintReportActions.CLEAR_HISTORY_FILE:
      return { ...state, fileName: null, fileUrl: null };
    default: {
      return state;
    }
  }
};

export default print;
